import { render, staticRenderFns } from "./AddAgentRegion.vue?vue&type=template&id=0035e8aa&scoped=true"
import script from "./AddAgentRegion.vue?vue&type=script&lang=ts"
export * from "./AddAgentRegion.vue?vue&type=script&lang=ts"
import style0 from "./AddAgentRegion.vue?vue&type=style&index=0&id=0035e8aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035e8aa",
  null
  
)

export default component.exports